<ng-container *ngIf="applies">
  <!-- Cookie banner: first visit, until a choice is recorded. -->
  <div class="cb-banner" *ngIf="showBanner" role="region" aria-label="Privacy and cookies">
    <div class="cb-banner-inner">
      <h2 class="cb-title">We value your privacy</h2>
      <p class="cb-copy">
        Atmavaan uses cookies to keep the site working, measure how it is used, and identify the businesses
        that visit us so our team can follow up. Under U.S. state privacy laws, the data we share with our
        analytics, advertising and visitor-identification partners counts as a &ldquo;sale&rdquo; or
        &ldquo;sharing&rdquo; of personal data. You can accept, reject non-essential cookies, or choose
        what to allow. Read our <a class="cb-inline-link" href="/legal/privacy-policy">Privacy Policy</a>.
      </p>
      <div class="cb-actions">
        <button type="button" class="cb-btn cb-btn-primary" (click)="acceptAll()">Accept all</button>
        <button type="button" class="cb-btn cb-btn-secondary" (click)="rejectNonEssential()">Reject non-essential</button>
        <button type="button" class="cb-btn cb-btn-link" (click)="openPreferences()">Cookie settings / Do not sell or share</button>
      </div>
    </div>
  </div>

  <!-- Preferences dialog: also opened from the footer link. -->
  <div class="cb-overlay" *ngIf="showPreferences" (click)="closePreferences()">
    <div class="cb-modal" role="dialog" aria-modal="true" aria-labelledby="cb-modal-title" (click)="$event.stopPropagation()">
      <div class="cb-modal-head">
        <h2 id="cb-modal-title">Privacy preferences &amp; do not sell/share my data</h2>
        <button type="button" class="cb-close" aria-label="Close privacy preferences" (click)="closePreferences()">&times;</button>
      </div>

      <div class="cb-modal-body">
        <p class="cb-lead">
          You have the right to opt out of the sale or sharing of your personal information and to withdraw
          your consent at any time. When you toggle off the categories below, we stop loading those tools
          in your browser.
        </p>

        <div class="cb-cat">
          <span class="cb-toggle cb-toggle-locked" aria-hidden="true"><span class="cb-knob"></span></span>
          <div class="cb-cat-meta">
            <div class="cb-cat-name">Strictly necessary</div>
            <div class="cb-cat-desc">Keeps the site and your Atmavaan account working and secure, and remembers this choice.</div>
            <div class="cb-locked-note">Always on</div>
          </div>
        </div>

        <div class="cb-cat">
          <button type="button" class="cb-toggle" role="switch" [attr.aria-checked]="draft.analytics"
            aria-label="Analytics cookies" (click)="toggle('analytics')"><span class="cb-knob"></span></button>
          <div class="cb-cat-meta">
            <div class="cb-cat-name">Analytics</div>
            <div class="cb-cat-desc">Uses Google Analytics to measure which pages and tools are used.</div>
          </div>
        </div>

        <div class="cb-cat">
          <button type="button" class="cb-toggle" role="switch" [attr.aria-checked]="draft.ads"
            [disabled]="gpc" aria-label="Advertising and visitor identification cookies"
            (click)="toggle('ads')"><span class="cb-knob"></span></button>
          <div class="cb-cat-meta">
            <div class="cb-cat-name">Advertising &amp; visitor ID <span class="cb-dns">(do not sell/share)</span></div>
            <div class="cb-cat-desc">
              Uses Google Ads to measure our ads and RB2B to identify the businesses (and, for U.S.
              visitors, the professionals) who visit, so our sales team can follow up. Turning this off
              opts you out of the &ldquo;sale&rdquo; or &ldquo;sharing&rdquo; of your data.
            </div>
            <div class="cb-locked-note" *ngIf="gpc">
              Your browser sends a Global Privacy Control signal, so this stays off.
            </div>
          </div>
        </div>
      </div>

      <div class="cb-modal-foot">
        <button type="button" class="cb-btn cb-btn-secondary" (click)="rejectNonEssential()">Reject non-essential</button>
        <button type="button" class="cb-btn cb-btn-primary" (click)="savePreferences()">Save my preferences</button>
      </div>
    </div>
  </div>
</ng-container>
